export default "__VITE_ASSET__BD6CUWCw__"